<template>
  <div class="skeleton certification-lab-skel">
    <div class="certification-lab-skel__tile skeleton__animate">
      <div class="certification-lab-skel__left">
        <p class="skeleton__animate--white certification-lab-skel__title"></p>
        <p class="skeleton__animate--white certification-lab-skel__bottom"></p>
      </div>
      <div class="certification-lab-skel__buttons">
        <p class="skeleton__animate--white certification-lab-skel__input"></p>
        <p class="skeleton__animate--white certification-lab-skel__button"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationLabSkel',
}
</script>

<style lang="scss" scoped>
.certification-lab-skel {
  margin: 0;
  padding-bottom: 33px;
  width: 100%;
  display: flex;
  align-items: center;
  &__wrapper {
    padding: 20px;
    display: flex;
    align-items: center;
    width: 100%;
  }
  &__tile {
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  &__left {
    width: 70%;
    padding-right: 200px;
  }
  &__buttons {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &__badge {
    margin: 0px auto;
    margin-bottom: 20px;
    width: 160px;
    height: 200px;
  }
  &__title {
    margin: 10px 0 10px;
    width: 220px;
    height: 22px;
  }
  &__input {
    margin: 0 10px;
    width: 220px;
    height: 45px;
  }
  &__bottom {
    height: 15px;
  }
  &__button {
    margin: 0;
    width: 100px;
    height: 45px;
  }
}
</style>
